var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllieCv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "illie_cv_svg__a",
    x: 30.241,
    y: 28.016,
    width: 139.517,
    height: 155.969,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2039d1",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illie_cv_svg__b",
    x: 34,
    y: 39,
    width: 122,
    height: 141,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2039d1",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#4b75ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-164.284 -961.679)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.285 961.674)",
    filter: "url(#illie_cv_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.429,
    height: 110.915,
    rx: 6,
    transform: "matrix(.99 .1 -.1 .99 59.83 40.02)",
    fill: "#c8d5ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.285 961.674)",
    filter: "url(#illie_cv_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 111,
    rx: 6,
    transform: "translate(49 44)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.525 1017.494)",
    fill: "#0d2976",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3,
    height: 4.2,
    rx: 2,
    y: 13.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.3,
    height: 4.7,
    rx: 2,
    y: 20.7
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.2,
    height: 4.2,
    rx: 2,
    y: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.3,
    height: 7.2,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.11 1059.03)",
    fill: "#2358f8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.033,
    height: 6.768,
    rx: 3.4,
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.458,
    height: 1.692,
    rx: 0.8,
    x: 5.499,
    y: 2.115,
    opacity: 0.315
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.15,
    height: 6.768,
    rx: 3.4,
    x: 32.571,
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.69,
    height: 1.692,
    rx: 0.8,
    x: 36.378,
    y: 2.115,
    opacity: 0.315
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.15,
    height: 6.768,
    rx: 3.4,
    y: 8.883,
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.69,
    height: 1.692,
    rx: 0.8,
    x: 3.807,
    y: 11.421,
    opacity: 0.315
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.879,
    height: 6.768,
    rx: 3.4,
    x: 22.842,
    y: 8.883,
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.035,
    height: 1.692,
    rx: 0.8,
    x: 29.187,
    y: 11.421,
    opacity: 0.315
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.033,
    height: 7.191,
    rx: 3.6,
    y: 17.343,
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.458,
    height: 1.692,
    rx: 0.8,
    x: 5.499,
    y: 20.304,
    opacity: 0.315
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.15,
    height: 7.191,
    rx: 3.6,
    x: 32.571,
    y: 17.343,
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.69,
    height: 1.692,
    rx: 0.8,
    x: 36.378,
    y: 20.304,
    opacity: 0.315
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#0d2976",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.612,
    height: 4.7,
    rx: 2,
    x: 250.994,
    y: 1090.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.3,
    height: 4.2,
    rx: 2,
    x: 250.994,
    y: 1098.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.187,
    height: 4.7,
    rx: 2,
    x: 250.994,
    y: 1105.6
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#cfdaf7",
    strokeWidth: 2,
    d: "M244.026 1116.785v-23.391"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.326,
    cy: 2.326,
    r: 2.326,
    transform: "translate(242.111 1090.758)",
    fill: "#2358f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.34 1039.751h14.267m-14.267 3.424h14.267m-14.267 3.424h14.267m-14.267 3.424h14.267",
    stroke: "#e6e9f1",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.501 1032.023l-2.472-1.176a1.063 1.063 0 01-.624-.96v-1.1a4.252 4.252 0 00.28-.342 6.347 6.347 0 00.92-1.762.886.886 0 00.659-.841v-1.182a.867.867 0 00-.31-.653v-1.703a2.285 2.285 0 00-.53-1.665 3.663 3.663 0 00-2.878-.985 3.662 3.662 0 00-2.878.985 2.286 2.286 0 00-.53 1.665v1.7a.866.866 0 00-.31.653v1.182a.872.872 0 00.429.741 5.8 5.8 0 001.121 2.2v1.077a1.066 1.066 0 01-.589.941l-2.284 1.188a8.476 8.476 0 01-2.456-2.908 8.4 8.4 0 1115.218-7.094 8.346 8.346 0 01.662 3.27 8.387 8.387 0 01-3.426 6.769z",
    fill: "#4b75ff",
    opacity: 0.406
  }))));
}
export default SvgIllieCv;